import * as React from "react";
import type { SVGProps } from "react";
const SvgCarDoor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#car-door_svg__a)">
      <path d="M19 22H9c-.46 0-.86-.31-.97-.76l-.25-1a7 7 0 0 0-2.91-4.13l-.43-.28c-.28-.19-.45-.5-.45-.83v-5c0-.27.11-.52.29-.71l5.84-5.83c.94-.94 2.2-1.46 3.54-1.46H19c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1m-9.22-2H18V4h-4.34c-.8 0-1.56.31-2.12.88L6 10.41v4.05a8.97 8.97 0 0 1 3.72 5.29l.06.24z" />
      <path d="M19 11H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M16 14h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="car-door_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCarDoor;
